import SportsBaseballIcon from "@mui/icons-material/SportsBaseball";
import GrandSlamWrapper from "./GrandSlamWrapper";
import Can from "../../common/Can";
import { Navigate } from "react-router";
import { usePermissionContext } from "../../../contexts/ProviderProvider";

export const Component = () => {
  const { views } = usePermissionContext();
  return (
    <Can
      action={views.VIEW}
      items={[views.GRANDSLAM]}
      els={<Navigate to="/ballpark" />}
    >
      <GrandSlamWrapper />
    </Can>
  );
};
export const icon = <SportsBaseballIcon />;
export const text = "Grand Slam";
export const componentName = "Grand Slam";
export const path = "grandslam/:university?/:sport?";
